import React, { useState, useEffect } from "react";
import { useSearchParams, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import FiltersSidebar from "../../components/Filters/FiltersSidebar";
import FiltersDrawer from "../../components/Filters/FiltersDrawer";
import ProductGrid from "../../components/ProductGrid/ProductGrid";
import FilterListIcon from "@mui/icons-material/FilterList";
import SortDropdown from "../../components/SortDropdown/SortDropdown";
import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import FilterMenu from "../../components/Filters/FilterMenu";
import { getActiveSearchProducts, getFilterProducts } from '../../actions/productActions'
import { getActiveBrands } from '../../actions/brandActions'
import { getActiveCategories } from "../../actions/categoryActions";
import { fetchMeta } from "../../actions/metaActions";
import { Helmet } from "react-helmet-async";
import "./Products.css";

// ... (keep your imports)

const Products = () => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const params = useParams();
  const { category, subCategory, brand, slug } = params;
  const q = searchParams.get("q") || "";

  const { products, error, loading } = useSelector(state => state.productsState);
  const { brands = [] } = useSelector(state => state.brandsState);
  const { categories = [] } = useSelector(state => state.categoriesState);
  const { meta } = useSelector((state) => state.metaState);

  const [drawerOpen, setDrawerOpen] = useState(false);

  const [filters, setFilters] = useState({
    category: category || "",
    subcategory: subCategory || "",
    brand: brand ? [brand] : [],
    sort: "newest",
    q: q // Include q here
  });

  // 1. Fetch initial data (Brands/Categories) once
  useEffect(() => {
    dispatch(getActiveBrands());
    dispatch(getActiveCategories());
  }, [dispatch]);

  // 2. Sync URL params to State
  useEffect(() => {
    setFilters((prev) => ({
      ...prev,
      category: category || "",
      subcategory: subCategory || "",
      brand: brand ? [brand] : prev.brand,
      q: q
    }));

    // Also fetch meta when URL changes
    dispatch(fetchMeta(slug, category, subCategory, brand));
  }, [category, subCategory, brand, q, slug, dispatch]);

  // 3. SINGLE source of truth for fetching products
  useEffect(() => {
    dispatch(getFilterProducts(filters));
  }, [dispatch, filters]);

  const handleFilterChange = (type, value) => {
    setFilters(prev => {
      if (type === "brand") {
        const newBrands = prev.brand.includes(value)
          ? prev.brand.filter(b => b !== value)
          : [...prev.brand, value];
        return { ...prev, brand: newBrands };
      }
      return { ...prev, [type]: value };
    });
  };

  const toggleDrawer = () => setDrawerOpen((prev) => !prev);

  return (
    <>
      <Helmet>
        <title>{meta?.seo?.metaTitle || "Products"}</title>
        <meta name="description" content={meta?.metaDescription} />
      </Helmet>

      <div className="custom-container">
        <Breadcrumbs />
        <div className="products-layout">
          <aside className="filters-container">
            <FilterMenu
              brands={brands}
              categories={categories}
              activeFilters={filters}
              onFilterChange={handleFilterChange} />
          </aside>

          <div className="products-main">
            {/* Add a loading spinner here */}
            {loading ? (
              <div className="centered-state">
                <div className="loading-spinner"></div>
              </div>
            ) : error ? (
              <div className="centered-state">
                <h3>Something went wrong</h3>
                <p>{error}</p>
              </div>
            ) : products && products.length > 0 ? (
              <>
                {/* <div className="products-header">
                  <SortDropdown
                    selected={filters.sort}
                    onChange={(val) => handleFilterChange("sort", val)} />
                </div> */}

                <div className="products-grid-container mb-5">
                  <ProductGrid products={products} />
                </div>
              </>
            ) : (
              <div className="centered-state">
                <h3>No products found</h3>
                <p>We couldn't find anything matching your current filters.</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Products;
